const organization = {
  organizations: 'Cuentas',
  search_organization: 'Buscar Cuentas',
  add_organization: 'Nueva cuenta',
  controllers: 'Controladores',
  organization: 'Cuenta',
  payment_methods: 'Métodos de pago',
  name_on_card: 'Nombre en la tarjeta',
  card_number: 'Número de tarjeta',
  expiration_date: 'Fecha de caducidad',
  is_default: 'Hacer como predeterminado',
  expires_at: 'La tarjeta caduca a las',
  select_organization_msg: 'Por favor vaya a cuentas y seleccione una',
  summary: 'Resumen',
  single_site: 'Sitio único',
  table: {
    company: 'COMPAÑÍA',
    full_name: 'NOMBRE COMPLETO',
    email: 'CORREO ELECTRÓNICO',
    country: 'PAÍS',
    address: 'DIRECCIÓN',
    status: 'ESTADO',
    site: 'SITIO',
    organization: 'CUENTA',
    firmware_version: 'VERSIÓN DE FIRMWARE',
  },
  form: {
    secondContact: 'Segundo contacto',
    create_admin: 'Crear un Administrador usuario',
    main_contact_first_name: 'Contacto principal - Nombre',
    main_contact_last_name: 'Contacto principal - Apellido',
    second_contact_first_name: 'Nombre',
    second_contact_last_name: 'Apellido',
  },
  information: {
    website: 'Sitio web',
  },
  modal: {
    delete_payment_description: 'Está seguro de eliminar esta tarjeta',
  },
  set_multisite_msg:
    '¿Está seguro de que desea cambiar <b>{{name}}</b> de sitio único a sitios múltiples?',
  set_singlesite_msg:
    '¿Está seguro de que desea cambiar <b>{{name}}</b> de sitios múltiples a sitio único?',
};

export default organization;
